
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2060.333-1770a.933.933 0 00-.3-.693l-6.097-6.084a1.094 1.094 0 00-.337-.239.9.9 0 00-.354-.074.906.906 0 00-.654.254.856.856 0 00-.264.645.977.977 0 00.068.366.877.877 0 00.2.3l2.073 2.105 3.525 3.223.273-.547-3.105-.186h-11.425a.922.922 0 00-.674.259.9.9 0 00-.264.669.909.909 0 00.264.682.922.922 0 00.674.259h11.426l3.105-.186-.273-.537-3.525 3.213-2.08 2.109a.877.877 0 00-.2.3.977.977 0 00-.068.366.845.845 0 00.264.635.906.906 0 00.654.254.931.931 0 00.664-.283l6.123-6.113a.913.913 0 00.307-.697z"}})])])
          )
        }
      }
    